export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken, 
           accessTokenPrivilege
         }
      } = store.getState();
      const accessTokenPrivilegeToken = localStorage.getItem('accessTokenPrivilege')
       var check_privilage = config.url.search("privilege-api");
       //console.log('check_privilage ',check_privilage, accessTokenPrivilegeToken)
       if (check_privilage > 0) {
       config.headers.Authorization = `Bearer ${accessTokenPrivilegeToken}`;
       } else {
      config.headers.Authorization = `Bearer ${authToken}`;
       }
      return config;
    },
    err => {
      if (err.response.status === 401) {
        window.location.assign("/logout");
      }
      return Promise.reject(err)
    }
  );
}
